import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { Grid, TextField, Icon, InputAdornment, Theme, createStyles, WithStyles, withStyles } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import ProductCategoriesFilter from 'src/shared/CategoriesFilter/ProductCategoriesFilter'
import autobind from 'autobind-decorator'
import { debounce } from 'ts-debounce'
import {isEmpty} from 'lodash'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import { fetchProductsDette, fetchProductsChange, fetchProductsPlacement } from 'src/core/redux/action/productsAction'
import { ProductCriteria } from 'src/type/criteria/productCriteria'

import ProductsChange from 'src/page/Consumer/Products/Flow/ProductsChange'
import ProductsDette from 'src/page/Consumer/Products/Flow/ProductsDette'
import ProductsPlacement from 'src/page/Consumer/Products/Flow/ProductsPlacement'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'

const styles = (t: Theme) => createStyles({
  root: {
    margin: `${t.spacing.unit*2}px auto`,
    maxWidth: 1200,
    padding: t.spacing.unit * 2,
    minHeight: `calc(100vh - 48px)`
  },
  divider: {
    margin: `${t.spacing.unit}px 0`
  }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

const actionsDette = new PaginateAction<any>("productsDette", fetchProductsDette)
const actionsChange = new PaginateAction<any>("productsChange", fetchProductsChange)
const actionsPlacement = new PaginateAction<any>("productsPlacement", fetchProductsPlacement)

class Products extends React.Component<IProps, {}> {

  render() {
    const {t, classes} = this.props
    
    return (
      <div className={classes.root}>
        <HelmetMeta title={t.App_title_page_Products}/>
        <Grid container>

          <Grid item xs={12}>
            <TextField
                  placeholder={t.products_global_search}
                  InputProps={{
                      startAdornment: <InputAdornment position="start">
                          <Icon>search</Icon>
                      </InputAdornment>,
                  }}
                  onChange={this.onGlobalSearchProduct}
                  fullWidth={true}
              />
          </Grid>
          <Grid item xs={12}>
              <ProductCategoriesFilter label={t.products_filter_par_categorie} onChange={this.debounceonFilterSearch} />
          </Grid>
          {this.generateConditionProducst("change") &&
            <Grid item xs={12}>
              <ProductsChange />
            </Grid>
          }
          {this.generateConditionProducst("dette") &&
            <Grid item xs={12}>
              <ProductsDette/>
            </Grid>
          }
          {this.generateConditionProducst("placement") &&
            <Grid item xs={12}>
              <ProductsPlacement />
            </Grid>
          }

        </Grid>
      </div>
    )
  }

  private generateConditionProducst = (type: string) => {
    const {is_mandataire, habilitations, category_partenaire_btob} = this.props.enterpriseSelected
    if(
      (type === "change" && !!category_partenaire_btob && category_partenaire_btob.includes('distributeur')) ||
      (type === "dette" && !!category_partenaire_btob && category_partenaire_btob.includes('distributeur'))
    ) {
      return false
    }
    if(
      (is_mandataire === false && habilitations.includes(type)) || is_mandataire === true 
    ){
      return true
    } else {
      return false
    }
  }
  
  private debounceonFilterSearch = debounce(this.filterByCategories, 300)
  private debounceonGlobalSearch = debounce(this.filterByName, 500)

  @autobind
  private filterByCategories(values: any){
    let filter;
    if(!isEmpty(values)){
      filter = {
        category_produit: values.get('produit').join(),
        category_principale: values.get('principale').join()
      }
    } 
    this.updateObjectFilter(filter)
  }

  @autobind
  private filterByName(values: any){
    this.updateFilter("global_search", values && values.length > 0 ? values : "")
  }

  /*
   category_principale must always be available
   TODO: optimize
  */
  private buildFilter(filter: any, criteria: ProductCriteria, tag: string){
    return {
      limit: criteria.limit,
      offset: criteria.offset,
      category_principale: (filter && filter.category_principale) ? filter.category_principale : tag,
      ...(filter && filter.category_produit ? {category_produit: filter.category_produit} : {category_produit: ""}),
    };
  }

  private updateFilter(name: string, value: string){
    const {updateCriteriaChange, updateCriteriaDette, updateCriteriaPlacement} = this.props
    updateCriteriaChange(name, value)
    updateCriteriaDette(name, value)
    updateCriteriaPlacement(name, value)
  }

  private updateObjectFilter(filter: any){
    const {updateCriteriaChangeByObject, updateCriteriaDetteByObject, updateCriteriaPlacementByObject, criteriaChange, criteriaDette, criteriaPlacement} = this.props
    updateCriteriaChangeByObject(this.buildFilter(filter, criteriaChange,  "change"))
    updateCriteriaDetteByObject(this.buildFilter(filter, criteriaDette, "dette"))
    updateCriteriaPlacementByObject(this.buildFilter(filter, criteriaPlacement, "placement"))

  }

  onGlobalSearchProduct = (e) => {
      this.debounceonGlobalSearch(e.target.value)
  };

}

const state2props = (state: RootState) => ({
  criteriaChange: state.paginate.productsChange.criteria,
  criteriaDette: state.paginate.productsDette.criteria,
  criteriaPlacement: state.paginate.productsPlacement.criteria,
  enterpriseSelected: state.accountInfo.enterpriseSelected
});

const dispatch2props = (dispatch: any) => ({
  updateCriteriaChangeByObject: (value: any) => dispatch(actionsChange.updateCriteriaByObject(value)),
  updateCriteriaDetteByObject: (value: any) => dispatch(actionsDette.updateCriteriaByObject(value)),
  updateCriteriaPlacementByObject: (value: any) => dispatch(actionsPlacement.updateCriteriaByObject(value)),
  updateCriteriaChange: (name: string, value: string) => dispatch(actionsChange.updateCriteria(name, value)),
  updateCriteriaDette: (name: string, value: string) => dispatch(actionsDette.updateCriteria(name, value)),
  updateCriteriaPlacement: (name: string, value: string) => dispatch(actionsPlacement.updateCriteria(name, value)),
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(Products)



// WEBPACK FOOTER //
// ./src/page/Consumer/Products/Products.tsx